<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:25:51
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Notification\MessageType\MessageType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-23 17:02:19
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_MessageType_list_title')"
    pad="0"
    @activated="activated"
    :addBtn="hasBtn('add-admin-message-type')"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :totalCount="totalCount"
        :filter-page-data="filterPageData"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.code="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.message_type_code) }}
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.message_type_name) }}
          </div>
        </template>
        <template v-slot:item.type="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.message_type_label) }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :viewBtn="hasBtn('view-admin-message-type')"
            :delBtn="hasBtn('delete-admin-message-type')"
            :editBtn="hasBtn('edit-admin-message-type')"
            editText="label_essweb_list_components_tools_editBtnLabel"
            :title="$t('label_essweb_MessageType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toView"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <template v-slot:page-actions></template>
    <!-- tools -->
    <template v-slot:tools-main>
      <newMessageType
        :show="showNewType"
        @close="showNewType = false"
        @new="onNew"
      />
      <editMessageType
        :show="showEditType"
        @close="
          showEditType = false;
          curUuid = null;
        "
        @save="onSave"
        :curUuid="curUuid"
      />
      <viewMessageType
        :show="showViewType"
        @close="
          showViewType = false;
          curViewUuid = null;
        "
        :curUuid="curViewUuid"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>

<script>
import { mapGetters } from "vuex";
import newMessageType from "@/Page/EssAdmin/Notification/MessageType/components/newMessageType";
import editMessageType from "@/Page/EssAdmin/Notification/MessageType/components/editMessageType";
import viewMessageType from "@/Page/EssAdmin/Notification/MessageType/components/viewMessageType";
export default {
  name: "MessageType",
  components: { newMessageType, viewMessageType, editMessageType },
  computed: {},
  data() {
    return {
      showNewType: false,
      curViewUuid: null,
      curUuid: null,
      totalCount: 0,
      showEditType: false,
      showViewType: false,
      headers: [
        {
          text: "label_essweb_MessageType_list_messageTypeNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimReason_form_codeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_MessageType_list_messageTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      showSelect: false,
      filterPageData: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "code",
          position: "right",
          label: "label_essweb_ClaimReason_form_codeLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_MessageType_list_messageTypeNameLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["message_type_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["message_type_code"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    toNew: function () {
      this.showNewType = true;
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_message_type",
        url: "/message-type/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_MessageType_list_deleteMessageTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEdit: function (uuid) {
      this.curUuid = uuid;
      this.showEditType = true;
    },
    toView: function (uuid) {
      this.curViewUuid = uuid;
      this.showViewType = true;
    },
    onNew: function (obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_message_type",
        url: "/message-type/add/",
        data: {
          message_type_name: this.$transCommonLangKey(obj.message_type_name),
          message_type_code: obj.message_type_code,
          message_type: obj.message_type,
          message_mode_uuid: obj.message_mode_uuid,
          mail_mode_uuid: obj.mail_mode_uuid,
          is_mail_send: obj.is_mail_send ? 1 : 0,
          is_message_send: obj.is_message_send ? 1 : 0,
          message_platform: obj.message_platform,
        },
      }).then((res) => {
        that.showNewType = false;
        that.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
      });
    },
    onSave: function (obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_message_type",
        url: "/message-type/update/",
        data: {
          uuid: obj.uuid,
          message_type_name: this.$transCommonLangKey(
            obj.message_type_name,
            obj.message_type_name_save
          ),
          message_type_code: obj.message_type_code,
          message_type: obj.message_type,
          message_mode_uuid: obj.message_mode_uuid,
          mail_mode_uuid: obj.mail_mode_uuid,
          is_mail_send: obj.is_mail_send ? 1 : 0,
          is_message_send: obj.is_message_send ? 1 : 0,
          message_platform: obj.message_platform,
        },
      }).then((res) => {
        that.showEditType = false;
        that.$showMessage({
          color: "success",
          text: that.$t("message_essweb_snckbar_actionSuccessLabel"),
          type: "success",
        });
        that.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
      });
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_message_type",
        url: "/message-type/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
  },
};
</script>
